import { twMerge } from "tailwind-merge";

export default function Label({
    title,
    htmlFor,
    overrideClasses,
    className,
    required = false,
    ...props
}) {
    const defaultClassNames = "flex gap-x-1 items-center text-sm font-medium";
    const classNames = overrideClasses
        ? overrideClasses
        : twMerge(defaultClassNames, className || "");

    return (
        <label htmlFor={htmlFor} className={classNames} {...props}>
            <p>
                {title}{" "}
                {required && (
                    <span className="text-sm font-medium text-red-600">*</span>
                )}
            </p>
        </label>
    );
}
